import { injectable } from 'inversify';
import { useAppSelector } from '../../state/hooks';
import { ThemeService } from './theme.service';

@injectable()
export class ThemeDomain {
  public constructor(private readonly themeService: ThemeService) {}

  dispatchSetTheme = (theme: string) => {
    this.themeService.dispatchSetTheme(theme);
  };

  useThemeSelector = () => {
    return useAppSelector(this.themeService.useThemeSelector);
  };
}
